import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><path d=\"M5.688 9.625A3.942 3.942 0 0 1 1.75 5.687 3.942 3.942 0 0 1 5.688 1.75a3.942 3.942 0 0 1 3.937 3.938 3.942 3.942 0 0 1-3.938 3.937m0-9.625A5.694 5.694 0 0 0 0 5.688a5.694 5.694 0 0 0 5.688 5.687 5.653 5.653 0 0 0 2.983-.848l3.088 3.089c.248.248.578.384.928.384.351 0 .68-.136.929-.384.247-.248.384-.578.384-.928 0-.351-.137-.68-.384-.929l-3.089-3.088c.537-.868.848-1.89.848-2.983A5.694 5.694 0 0 0 5.687 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/search.svg
// module id = 1559
// module chunks = 0